import { render } from "./company_verification_and_score.html?vue&type=template&id=1c3e4976&external"
import script from "./company_verification_and_score.js?vue&type=script&lang=js&external"
export * from "./company_verification_and_score.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__